import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class ProveedorService {
  async getAllMetodoPagos() { 
    return await fetchWrapper.get(`${ruta}/metodo_pagos`);
   }
}